module.exports = __webpack_public_path__ + "static/media/One side Angle's Class III 1.684ffc67.png";